import React, { useEffect } from 'react';
import { Notification } from '../../NotificationCenter';
import { useNotifications } from '../../NotificationContext';

interface ReservationHandlerProps {
  notification: Notification;
  setNotification: React.Dispatch<React.SetStateAction<any>>;
}

interface ReservationDetails {
  reservation_id: number;
  client_id: number | null; // Cambiado a null para permitir reservas sin cliente
  client_name: string;
  email: string;
  phone_number: string;
  reservation_date: string;
  local_id: number;
  init: number;
  end: number;
  n_people: number;
  mesa_id: number;
  mesa_num: number;
  description: string;
  confirmed: boolean;
  approved: boolean;
  attended: boolean;
  cancelled: boolean;
  arrived: boolean; // Añadido para que coincida con el tipo esperado
}
function fromDynamoDB(dynamoObj: any): ReservationDetails {
  return {
    reservation_id: Number(dynamoObj.reservation_id?.N ?? 0),
    client_id: 'client_id' in dynamoObj && 'N' in dynamoObj.client_id ? Number(dynamoObj.client_id.N) : 0,
    client_name: dynamoObj.client_name?.S ?? '',
    email: dynamoObj.email?.S ?? '',
    phone_number: dynamoObj.phone_number?.S ?? '',
    reservation_date: dynamoObj.reservation_date?.S ?? '',
    local_id: Number(dynamoObj.local_id?.N ?? 0),
    init: Number(dynamoObj.init?.N ?? 0),
    end: Number(dynamoObj.end?.N ?? 0),
    n_people: Number(dynamoObj.n_people?.N ?? 0),
    mesa_id: Number(dynamoObj.mesa_id?.N ?? 0),
    mesa_num: Number(dynamoObj.mesa_num?.N ?? 0),
    description: dynamoObj.description?.S ?? '',
    confirmed: Boolean(dynamoObj.confirmed?.BOOL ?? false),
    approved: Boolean(dynamoObj.approved?.BOOL ?? false),
    attended: Boolean(dynamoObj.attended?.BOOL ?? false),
    cancelled: Boolean(dynamoObj.cancelled?.BOOL ?? false),
    arrived: Boolean(dynamoObj.arrived?.BOOL ?? false), // Añadido para que coincida con el tipo esperado
  };
}

export const ReservationHandler: React.FC<ReservationHandlerProps> = ({ notification, setNotification }) => {
  const { setReservations } = useNotifications();

  useEffect(() => {
    if (
      notification &&
      notification.data &&
      notification.data.M &&
      notification.data.M.content &&
      notification.data.M.content.M
    ) {
      const reserva = fromDynamoDB(notification.data.M.content.M);
      setReservations(prev => [reserva, ...prev]);
      setNotification(null);
    }
  }, [notification, setReservations, setNotification]);

  return null;
};